import { Link } from "react-router-dom";
import { MdNotifications } from "react-icons/md";

export default function NotificationIcon() {
  return (
    <button className="flex justify-end w-full top-10 left-0 pt-4">
      <Link to="/app/notification">
        <MdNotifications className="text-xl" />
      </Link>
    </button>
  );
}
